import { BehaviorContext } from '../../behavior-context';
import { Behavior } from '../../behavior';
import {
  SESSION_KEY_INVOICE,
  GLOBAL_CONTEXT_KEY_INVOICE_RESULT,
} from './constants';
import { Injectable } from '@angular/core';

@Injectable()
export class SubmitInvoiceBehavior implements Behavior {
  async execute(args: any, context: BehaviorContext): Promise<any> {
    // Temporarily retrieve in session storage
    const invoiceData = JSON.parse(sessionStorage.getItem(SESSION_KEY_INVOICE));

    // Temporary mock request

    const result = await new Promise((res, rej) => {
      setTimeout(() => {
        res({
          esignURL: 'http://esignurl.com',
        });
      }, 2000);
    });

    context.set(GLOBAL_CONTEXT_KEY_INVOICE_RESULT, result);
  }
}
